export default __webpack_public_path__ + "static/media/Mini Milling MANIX.2e703d39.png";